import axios from "axios";
import { getApiUrl } from "../core/config/api.js";

const globalWindow = typeof window !== "undefined" ? window : {};

const dataStore = {
  CATEGORIES: null,
  COUNTRIES: null,
  NATIONALITIES: null,
  LEVELS: null,
  REWARDS: null,
};

const initializeWindowData = async () => {
  if (globalWindow.NATIONALITIES && globalWindow.NATIONALITIES.length > 0) {
    dataStore.NATIONALITIES = globalWindow.NATIONALITIES;
    dataStore.COUNTRIES = globalWindow.COUNTRIES || [];
    dataStore.CATEGORIES = globalWindow.CATEGORIES || [];
    dataStore.LEVELS = globalWindow.LEVELS || [];
    dataStore.REWARDS = globalWindow.REWARDS || [];
    return;
  }

  try {
    const [countriesRes, nationalitiesRes, categoriesRes] =
      await Promise.allSettled([
        axios.get(getApiUrl("/api/countries")),
        axios.get(getApiUrl("/api/nationalities")),
        axios.get(getApiUrl("/api/categories")),
      ]);

    if (countriesRes.status === "fulfilled" && countriesRes.value?.data) {
      dataStore.COUNTRIES = countriesRes.value.data;
      globalWindow.COUNTRIES = countriesRes.value.data;
    }

    if (
      nationalitiesRes.status === "fulfilled" &&
      nationalitiesRes.value?.data
    ) {
      dataStore.NATIONALITIES = nationalitiesRes.value.data;
      globalWindow.NATIONALITIES = nationalitiesRes.value.data;
    }

    if (categoriesRes.status === "fulfilled" && categoriesRes.value?.data) {
      dataStore.CATEGORIES = categoriesRes.value.data;
      globalWindow.CATEGORIES = categoriesRes.value.data;
    }
  } catch (err) {
    console.warn("Failed to initialize window data from API:", err);
  }
};

// Start initialization (non-blocking)
initializeWindowData();

const Window = {
  get APP_ENV() {
    return globalWindow.APP_ENV || "production";
  },

  // Data - use getters to check window first, then dataStore
  get CATEGORIES() {
    return globalWindow.CATEGORIES || dataStore.CATEGORIES || [];
  },

  get COUNTRIES() {
    return globalWindow.COUNTRIES || dataStore.COUNTRIES || [];
  },

  get NATIONALITIES() {
    return globalWindow.NATIONALITIES || dataStore.NATIONALITIES || [];
  },

  get LEVELS() {
    return globalWindow.LEVELS || dataStore.LEVELS || [];
  },

  get REWARDS() {
    return globalWindow.REWARDS || dataStore.REWARDS || [];
  },

  // User referrals
  get REFERRAL_CODE() {
    return globalWindow.REFERRAL_CODE;
  },

  get REFERRAL_TYPE() {
    return globalWindow.REFERRAL_TYPE;
  },

  // Admin-created invitations
  get INVITED_USER() {
    return globalWindow.INVITED_USER;
  },

  // Checkout
  get BANK_TRANSFER_DETAILS() {
    return globalWindow.BANK_TRANSFER_DETAILS;
  },

  get NEEDS_SELLER_CONFIRMATION() {
    return globalWindow.NEEDS_SELLER_CONFIRMATION;
  },

  // API Keys
  get FACEBOOK_CLIENT() {
    return globalWindow.FACEBOOK_CLIENT;
  },

  get LINKEDIN_CLIENT() {
    return globalWindow.LINKEDIN_CLIENT;
  },

  get GOOGLE_CLIENT() {
    return globalWindow.GOOGLE_CLIENT;
  },

  // Stripe
  Stripe: (key) => globalWindow.Stripe(key),

  get STRIPE_KEY() {
    return globalWindow.STRIPE_KEY;
  },

  get RECAPTCHA_SITE_KEY() {
    return globalWindow.RECAPTCHA_SITE_KEY;
  },

  get RECAPTCHA_SECRET_KEY() {
    return globalWindow.RECAPTCHA_SECRET_KEY;
  },

  // Location
  get location() {
    return (
      globalWindow.location || {
        protocol: "https:",
        host: "www.retail-circle.com",
      }
    );
  },
};

export default Window;
